import {
	wait,
	getLocalData,
	setLocalData,
	delLocalData,
	firebaseMessage,
	ganaSendEvent,
	checkBrowser
} from '@util';
import {
	COMMONAPI,
	GAMEAPI
} from '@api';
import {
	useCommonStore
} from '@stores/common';
import {
	storeToRefs
} from 'pinia';
import {
	ref,
	getCurrentInstance
} from 'vue';
import {
	default as config,
	handleChannel,
	languageEnum
} from '@config';
import {
	useUserSocket,
	useMarqueeSocket
} from '@hooks/socket';
import PageConfig from '@/pages.json';
// import { $t } from './language';

function getGameCategoryFun(siteConfigRes, proxy, resolve, reject) {
	try {
		const store = useCommonStore();
		const {
			setCheckingSiteConfig,
			setCategoryData
		} = store;

		// 获取分类
		return COMMONAPI.queryNavigator({}).then((tabRes) => {
			GAMEAPI.GetGameCategory().then((cateRes) => {
				const mergedArray = tabRes.map((item1) => {
					item1 = {
						...item1,
						cateName: item1.name,
						tabIndex: item1.name,
						tabPath: item1.path,
						catePath: '',
						visible: true,
					};
					const matchedItem2 = cateRes.find((item2) => item2.code === item1.cateCode);
					if (matchedItem2) {
						return {
							...matchedItem2,
							...item1,
							catePath: matchedItem2.path, // 分类接口返回的path
						};
					}
					return item1;
				});
				const defaultCode = PageConfig.pages[0].style.code;
				const defaultExpand = mergedArray.filter((item) => item.code === defaultCode || item.cateCode ===
					defaultCode);
				const configExpand = mergedArray.filter((item) => item.expand === true);
				setCategoryData('clean');
				// window.log("[setCategoryData] ",mergedArray, configExpand[0] ,defaultExpand[0])
				setCategoryData(mergedArray, configExpand[0] || defaultExpand[0]);
				setCheckingSiteConfig(false);
				resolve({
					siteConfigRes,
					queryGamesCategoryRes: mergedArray,
				});
			});
		});
	} catch (error) {
		return new Promise((resolve, reject) => {
			setCheckingSiteConfig(false);
			reject(error);
		});
	}
}

function getServiceInfoFun() {
	COMMONAPI.GetServiceInfo().then((res) => {
		const store = useCommonStore();
		store.setServiceInfo(res);
		setLocalData('serviceInfo', res);
	});
}

export async function appLaunchFun(proxy) {
	const store = useCommonStore();
	const {
		setCheckSiteConfig,
		setCheckingSiteConfig,
		setCheckSiteConfigRes
	} = store;
	const {
		checkSiteConfig,
		checkingSiteConfig,
	} = storeToRefs(store);

	// window.log("[appLaunch] appLaunchFun",proxy,checkSiteConfig.value)
	// if (getLocalData('siteCode') && checkSiteConfig.value) {
	// 	window.log("[appLaunch] appLaunchFun return",getLocalData('siteCode') , checkSiteConfig.value)
	// 	return;
	// }else 
	if(checkingSiteConfig.value){
		let waitTime = 0;
		while(checkingSiteConfig.value){
			// window.log("[appLaunch] await wait(100)",checkingSiteConfig.value);
			await wait(100);
			waitTime+=100;
		}
		window.log("[appLaunch] wait",waitTime,checkingSiteConfig.value);
		return;
	}else{
		return new Promise((resolve, reject) => {
			const {
				proxy,
				appContext
			} = getCurrentInstance();
			const global = appContext.config.globalProperties;
			setCheckingSiteConfig(true);
			COMMONAPI.GetBaseInfoByUrl()
				.then(async (res) => {
					if (location.hostname === 'localhost') {
						res.country = 'MX';
					}
	
					// res.country = 'BR'//巴西
					// res.country = 'CL'//智利
					// res.country = 'CO'//哥伦比亚
					// res.country = 'PE'//秘鲁
					// res.country = 'AR'//阿根廷
					let lang = languageEnum[res.country];
					if (res.country == 'NG') {
						lang = store.nowLang;
					}
					
					window.log('---res: ', res);
					window.log('---config: ', config);
					// lang = 'en';
					// lang = 'br';
					// lang = 'co';
					// lang = 'cl';
					// lang = 'pe';
					console.log('---设置语言: ', lang);
					uni.setLocale(lang);
					global.$i18n.global.locale = lang;
	
					// // 重置语言---！！！勿动
					// let phoneLen = $t('common.phoneNumber');
					// phoneLen = 'phone number: ' + phoneLen;
					// console.log('reset-lang: ', phoneLen);
	
					const clientInfo = checkBrowser();
					window.log("~~~~~~~~~~~[clientInfo]",clientInfo)
	
					// #ifdef H5
					document.title = res?.siteName;
					// #endif
					setCheckSiteConfig(true);
					setCheckSiteConfigRes(res);
					for (let key in res) {
						setLocalData(key, res[key]);
					}
	
					await getGameCategoryFun(res, proxy, resolve, reject);
	
					// setCheckingSiteConfig(false);
					try {
						getServiceInfoFun();
						firebaseMessage();
					} catch (error) {}
				})
				.catch((err) => {
					console.log('---catch-response---checkSiteConfig');
					//上报错误
					ganaSendEvent(`ERROR_SEND_checkSiteConfig`, {
						err: err,
					});
					setCheckingSiteConfig(false);
					setCheckSiteConfig(false);
					let res = {
						nationCode: '',
						nationName: '',
						areaCode: '',
						currency: '',
						lang: '',
						siteName: '',
						keyWords: '',
						description: null,
						siteLogo: '',
					};
					for (let key in res) {
						setLocalData(key, '');
					}
					reject(err);
				});
		});
	}
}